import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Image } from "react-bootstrap";
import {
  Box,
  Card,
  CardContent,
  CardActions,
  Collapse,
  IconButton,
  Typography,
} from "@material-ui/core";
import AppsIcon from "@material-ui/icons/Apps";
import CloseTwoToneIcon from "@material-ui/icons/CloseTwoTone";
import Draggable, { DraggableCore } from "react-draggable";

import Timer from "react-compound-timer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Device } from "twilio-client";
import { get_twilio_calling } from "../../../store/actions/dashboardAction/addingAction";
import isEmpty from "../../../store/validation/is-Empty";
import { PopupActionButton } from "../buttonReusableComponent/ButtonReusableComponent";
import Alert from "react-s-alert";
import { SET_CALLING_INFO, SET_TWILIO_TOKEN } from "../../../store/types";

const CallingCardDraggable = (props) => {
  const dispatch = useDispatch();
  const [openCard, setCard] = useState(false);
  const [openCallingCard, setOpenCallingCard] = useState(false);
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const callingDataPoup = useSelector((state) => {
    return !isEmpty(state.vendorOrdering)
      ? state.vendorOrdering.callingInfo
      : "";
  });

  const twilioToken = useSelector((state) => {
    return !isEmpty(state.vendorOrdering)
      ? state.vendorOrdering.TwilioCallingToken
      : "";
  });

  const [state, setState] = useState({
    activeDrags: 0,
    deltaPosition: {
      x: 0,
      y: 0,
    },
    controlledPosition: {
      x: -400,
      y: 200,
    },
    vendorDetails: {},
    onPhone: false,
    log: "",
    muted: false,
    time: 0,
  });

  // useEffect(() => {
  //   const token = auth?.user?.accessToken;
  //   if (get_twilio_calling) {
  //     dispatch(get_twilio_calling(token, callback));
  //   }
  //   // if (!isEmpty(callingDataPoup) !== state.vendorDetails) {
  //   //   setState({
  //   //     ...state,
  //   //     vendorDetails:
  //   //       !isEmpty(callingDataPoup) && callingDataPoup ? callingDataPoup : {},
  //   //   });
  //   //   setCard(
  //   //     !isEmpty(callingDataPoup) && callingDataPoup?.modelActive ? true : false
  //   //   );
  //   // }
  // }, []);

  useEffect(() => {
    const token = auth?.user?.accessToken;
    if (get_twilio_calling) {
      dispatch(get_twilio_calling(token, callback));
    }
  }, [twilioToken === null]);

  const onStart = () => {
    setState({ ...state, activeDrags: ++state.activeDrags });
  };

  const onStop = () => {
    setState({ ...state, activeDrags: --state.activeDrags });
  };

  /********************************
   * @DESC All USE_EFFECT FUCTION
   ********************************/
  useEffect(() => {
    setState({
      ...state,
      vendorDetails:
        callingDataPoup !== undefined && callingDataPoup !== null
          ? callingDataPoup
          : {},
    });
    setCard(
      !isEmpty(callingDataPoup) && callingDataPoup?.modelActive ? true : false
    );
  }, [!isEmpty(callingDataPoup) && callingDataPoup?.modelActive]);

  // useEffect(() => {
  //   if (
  //     Object.keys(state.vendorDetails).length === 0 &&
  //     state.vendorDetails.constructor === Object
  //   ) {
  //     setState({
  //       ...state,
  //       vendorDetails:
  //         callingDataPoup !== undefined && callingDataPoup !== null
  //           ? callingDataPoup
  //           : {},
  //     });
  //     setCard(
  //       !isEmpty(callingDataPoup) && callingDataPoup?.modelActive ? true : false
  //     );
  //   }
  // }, [state.vendorDetails]);

  const onOpenClosedPopup = () => {
    let formData = null;
    dispatch({ type: SET_CALLING_INFO, payload: formData });
    setCard(false);
    setOpenCallingCard(false);
  };

  const callback = (token) => {
    Device.setup(token, {
      closeProtection: true,
      enableIceRestart: true,
      edge: "roaming",
    });
    Device.on("ready", (ready) => {
      setState({
        ...state,
        log: "Device Ready To Connected",
        vendorDetails: callingDataPoup,
      });
      // state.log = "Connected";
      // let params = { number: mobileNumber };
      // Device.connect(params);
    });
    Device.on("error", (error) => {
      // Alert.error(`<h4>${error}</h4>`, {
      //   position: "top-right",
      //   effect: "bouncyflip",
      //   beep: true,
      //   html: true,
      //   timeout: 3000,
      //   offset: 35,
      // });
    });
    Device.on("connect", (connection) => {
      setState({
        ...state,
        onPhone: true,
        log: connection.status(),
        vendorDetails: callingDataPoup,
      });
    });
    Device.on("incoming", (connection) => {
      connection.accept();
      this.setState({
        log: connection.status(),
      });
    });
    Device.on("cancel", (connection) => {
      setState({
        ...state,
        onPhone: false,
        log: connection.status(),
      });
    });
    Device.on("disconnect", (connection) => {
      let formData = null;
      setState({
        ...state,
        onPhone: false,
        log: "Device Ready To Connected",
      });
      dispatch({ type: SET_CALLING_INFO, payload: formData });
      setOpenCallingCard(false);
      setCard(false);
    });
    Device.on("offline", (connection) => {
      setState({
        ...state,
        onPhone: false,
        log: connection.status(),
      });
    });
  };

  const onCallConnect = (e) => {
    if (
      state?.vendorDetails?.userName !== undefined &&
      state?.vendorDetails?.userName !== null &&
      state?.vendorDetails?.mobile_number !== undefined &&
      state?.vendorDetails?.mobile_number !== null
    ) {
      setOpenCallingCard(true);
      const vendorInfo = state.vendorDetails;
      const mobileNumber = vendorInfo?.country_code + vendorInfo?.mobile_number;
      let params = { number: mobileNumber };
      Device.connect(params);
    } else {
      Alert.error(`<h4>User Details Not Available</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  const onCallDisconnect = () => {
    let formData = null;
    if (state.log === "Device Ready To Connected") {
      console.log("Device Ready To Connected");
      Device.destroy();
      dispatch({ type: SET_TWILIO_TOKEN, payload: formData });
    } else {
      console.log("Device Active");
      Device.disconnectAll();
      dispatch({ type: SET_CALLING_INFO, payload: formData });
    }
    setOpenCallingCard(false);
    setCard(false);
  };

  // Handle muting
  const handleToggleMute = () => {
    var muted = state.muted;
    setState({
      ...state,
      muted: muted,
    });
    Device.activeConnection().mute(muted);
  };

  const dragHandlers = { onStart: onStart, onStop: onStop };
  return (
    <React.Fragment>
      {/* <Button
        variant="link"
        className={"enIconBtn mr-3"}
        onClick={() => setCard(!openCard)}
      >
        <Image
          src={require("../../../assets/images/UserManagement/phone.svg")}
          alt="Call"
          title="Calling Button"
          fluid
        />
      </Button> */}
      {openCard ? (
        <Draggable {...dragHandlers}>
          <Box
            sx={{ minWidth: 275 }}
            style={{
              position: "fixed",
              top: "40%",
              right: "40%",
              zIndex: 2147483650,
            }}
            className="bg-white"
          >
            <Card variant="outlined">
              <CallingCard
                state={state}
                openCallingCard={openCallingCard}
                displayButton={props?.displayButton}
                openCloseCard={onOpenClosedPopup}
                onCallConnect={onCallConnect}
                onClosedCallback={onCallDisconnect}
                onMuteToggle={handleToggleMute}
                callingDataPoup={callingDataPoup}
              />
            </Card>
          </Box>
        </Draggable>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default CallingCardDraggable;

export const CallingCard = (props) => {
  return (
    <React.Fragment>
      <CardContent className="p-0">
        <div className="col-12">
          <div className="row align-items-center">
            <div className="col-12 py-1 bg-dark text-center">
              <AppsIcon
                color="primary"
                fontSize="small"
                style={{ cursor: "pointer" }}
                //   onClick={handleTooltipOpen}
              />
            </div>
            <div className="col-10 my-3">
              <div className="f18-700">
                Call {props?.callingDataPoup?.userName}
              </div>
            </div>
            <div className="col-2 my-3 text-right">
              {props?.state?.log === "Device Ready To Connected" ? (
                <CloseTwoToneIcon
                  fontSize="medium"
                  style={{ cursor: "pointer" }}
                  onClick={props.openCloseCard}
                />
              ) : null}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <p className="py-3 f14-500">
                Status:{" "}
                <span className="text-success">{props?.state?.log}</span>
                {/* {props?.callingDataPoup?.userName} */}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
      {props?.openCallingCard ? (
        <CardActions className="p-0 py-3">
          <div className="col-12">
            <div className="row">
              <IconButton
                onClick={props.onMuteToggle}
                className="enCallControl mr-3"
              >
                <Image
                  src={
                    props.state.muted
                      ? require("../../../assets/images/UserManagement/mute.svg")
                      : require("../../../assets/images/UserManagement/mic.svg")
                  }
                  alt="mic"
                  title="mic"
                  className={props.state.muted ? "p-2" : ""}
                  style={{
                    width: "58px",
                    backgroundColor: props.state.muted ? "#fff" : "",
                    borderRadius: props.state.muted ? "50px" : "",
                  }}
                />
              </IconButton>
              <IconButton
                onClick={props.onClosedCallback}
                className="enCallControl"
              >
                <Image
                  src={require("../../../assets/images/UserManagement/off.svg")}
                  alt="Closed"
                  title="Closed"
                  style={{ width: "58px" }}
                />
              </IconButton>
            </div>
          </div>
        </CardActions>
      ) : (
        <CardActions className="p-0 py-3">
          <div className="col-12">
            <div className="row">
              <div className="col">
                <PopupActionButton
                  buttonText="No"
                  buttonType="button"
                  buttonClass="noButton"
                  onClick={props.openCloseCard}
                />
              </div>
              <div className="col text-right">
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={props.onCallConnect}
                />
              </div>
            </div>
          </div>
        </CardActions>
      )}
    </React.Fragment>
  );
};
